<template>
    <b-container fluid>
        <b-row>
            <b-col cols="auto" class="mr-auto">
                <h5 class="my-6">Dane osobowe</h5>
            </b-col>
            <b-col cols="auto">
              <b-row>
                <b-col cols="auto" class="mr-auto">
                  <vs-button type="border round" @click="toggleEdit">{{disabledForm ? 'Edytuj' : 'Anuluj' }}</vs-button>
                </b-col>
                <b-col cols="auto" v-if="!disabledForm">
                  <vs-button type="border round" @click="updateMe">Zapisz</vs-button>
                </b-col>
              </b-row>
            </b-col>
        </b-row>
        <b-row v-if="user">
          <b-col md="6">
                <b-row>
                  <b-col>
                    <vs-input
                      :disabled="disabledForm"
                      label="Email"
                      v-model="user.email"
                      class="w-100 mt-4"
                   />
                    <field-error :errorsBag="formErrors" fieldName="email" />
                  </b-col>
                </b-row>
                 <b-row>
                  <b-col>
                   <vs-input
                      :disabled="disabledForm"
                      label="Imię"
                      v-model="user.first_name"
                      class="w-100 mt-4"
                   />
                    <field-error :errorsBag="formErrors" fieldName="first_name" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <vs-input
                      :disabled="disabledForm"
                      label="Nazwisko"
                      v-model="user.last_name"
                      class="w-100 mt-4"
                   />
                    <field-error :errorsBag="formErrors" fieldName="last_name" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-select
                      :disabled="disabledForm"
                      :options="genderItems"
                      v-model="user.gender"
                      class="w-100 mt-4 h-12"
                    />
                    <field-error :errorsBag="formErrors" fieldName="gender" />
                  </b-col>
                </b-row>
            </b-col>
            <b-col md="6">
              <b-row>
                <b-col class="mt-4">
                  <label class="vs-input--label">Powiat</label>
                  <b-form-select
                    :disabled="disabledForm"
                    :options="provinceItems"
                    v-model="user.province"
                    class="w-100 h-12"
                  />
                  <field-error :errorsBag="formErrors" fieldName="province" />
                </b-col>
              </b-row>
             <b-row>
              <b-col>
                <vs-input
                  :disabled="disabledForm"
                  label="Nazwa instytucji"
                  v-model="user.employment_company"
                  class="w-100 mt-4"
               />
                <field-error :errorsBag="formErrors" fieldName="employment_company" />
              </b-col>
            </b-row>
            <b-row>
              <b-col class="mt-4">
                <label class="vs-input--label">Stanowisko służbowe</label>
                <b-form-select
                  :disabled="disabledForm"
                  :options="employmentPositionItems"
                  v-model="user.employment_position"
                  class="w-100 h-12"
                />
                <field-error :errorsBag="formErrors" fieldName="employment_position" />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <vs-input
                  v-if="user.employment_position==='lekarz'"
                  :disabled="disabledForm"
                  label="Nr licencji wykonywania zawodu"
                  v-model="user.license_number"
                  class="w-100 mt-4"
                />
                <field-error :errorsBag="formErrors" fieldName="license_number" />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
    </b-container>
</template>

<script>
import {userFormItems} from './../../mixins/users/usersMixin'
import FieldError from './../../components/wod/forms/FieldError'
import notification from '../../notification'

export default {
    name:'UserData',
    mixins: [userFormItems],
    components:{
        FieldError
    },
    data(){
        return {
            user: null,
            disabledForm: true,
            formErrors: {},
        }
    },
  mounted() {
      this.getMe()
  },
  methods:{
      toggleEdit(){
        this.disabledForm = !this.disabledForm
        this.formErrors = {}
      },
      updateMe(){
        this.$vs.loading()
        const user = this.user
        const payload = Object.keys(user)
          .filter(function (k) {
            return user[k] != null;
          })
          .reduce(function (acc, k) {
            acc[k] = typeof user[k] === "object" ? removeEmpty(user[k]) : user[k];
            return acc;
          }, {});
        this.$store.dispatch('auth/updateLoggedInUser', payload)
        .then(res => {
          this.$vs.notify(notification.success('Dane zostały zaktualizowane'))
          this.toggleEdit()
        })
        .catch(error => {
          if(error.response){
            if(error.response && error.response.status == 422){
              this.formErrors =  error.response.data.errors
            }
            else {
              this.$vs.notify(notification.error(error.message))
            }
          }
        })
        .finally(()=>{
          this.$vs.loading.close()
        })
      },

    getMe(){
      this.$vs.loading()
      this.$store.dispatch('auth/getLoggedInUser')
        .then(() => {
          this.user = {...this.$store.state.auth.loggedInUser}
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
        .finally(()=>{
          this.$vs.loading.close()
        })
    }
    }
}
</script>

<style>

</style>
